const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}
document.addEventListener('DOMContentLoaded', function () {
  const postalCodeInput = document.getElementById('AddressZipNew');
    const prefectureSelect = document.getElementById('AddressProvinceNew');

    // 郵便番号の最初の3桁と都道府県の対応データ
    const postalToPrefecture = {
        '100': '東京都', '060': '北海道', '530': '大阪府', 
        // ここに必要な郵便番号と都道府県を追加してください
    };

    // 郵便番号が入力されたら自動的に都道府県を選択
    postalCodeInput.addEventListener('input', function () {
        const postalPrefix = postalCodeInput.value.slice(0, 3);  // 郵便番号の先頭3桁を取得
        const prefecture = postalToPrefecture[postalPrefix];

        if (prefecture) {
            // 都道府県が見つかった場合、該当するオプションを選択
            Array.from(prefectureSelect.options).forEach(option => {
                if (option.textContent === prefecture) {
                    prefectureSelect.value = option.value;
                }
            });
        }
    });
    // "AddAddress" 内の必須フィールドに "*" を追加する処理
    const addAddressSection = document.getElementById('AddAddress');
    if (addAddressSection) {
        // required 属性を持つ input 要素を対象とする
        addAddressSection.querySelectorAll('input[required]').forEach(input => {
            const label = addAddressSection.querySelector(`label[for="${input.id}"]`);
            if (label) {
                // ラベルに "*" がまだ追加されていない場合のみ追加
                if (!label.classList.contains('required-label')) {
                    label.innerHTML += ' <span class="required-marker">*必須</span>';
                    label.classList.add('required-label');
                }
            }
        });
    }

    // スタイルを追加（必要に応じてカスタマイズ）
    const style = document.createElement('style');
    style.textContent = `
        .required-marker {
            margin-left: 4px;
        }
    `;
    document.head.appendChild(style);
  
});